<template>
  <div id="sites" style="text-align: right;">
    <el-form :model="keywords" size="small" inline>
      <el-form-item prop="shopName__icontains" label="站点名称">
        <el-input v-model="keywords.shopName__icontains" placeholder="请输入站点名称搜索"/>
      </el-form-item>
      <el-form-item>
        <el-button-group>
          <el-button type="primary" @click="getSites(1)"><i class="fa fa-search"></i>站点搜索</el-button>
          <el-button type="primary" @click="addShow = true">+ 新增站店</el-button>
        </el-button-group>
      </el-form-item>
    </el-form>
    <div style="display: block">
      <el-table :data="tableDate" v-loading="tableLoad" element-loading-text="拼命加载中..." element-loading-spinner="el-icon-loading" stripe>
        <el-table-column prop="ID" label="ID"></el-table-column>
        <el-table-column prop="shortName" label="店铺名称"></el-table-column>
        <el-table-column prop="supportCurrency" label="站点支持货币"></el-table-column>
        <el-table-column prop="CountryCode" label="站点国家"></el-table-column>
        <el-table-column prop="currency" label="站点货币"></el-table-column>
        <el-table-column label="站点管理" align="right" fixed="right">
          <template slot-scope="scope">
            <el-button type="text">模板配置</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="getSites"
        :current-page.sync="tablePage.page"
        :page-size="15"
        layout="total, prev, pager, next"
        :total="tablePage.total">
      </el-pagination>
    </div>
    <el-dialog :visible.sync="addShow">
      <h4 slot="title">新增站点</h4>
      <el-form :model="currNew" ref="newForm">
        <el-form-item prop="shortName" label="店铺名称" required>
          <el-input v-model="currNew.shortName" placeholder="请输入站点名称"/>
        </el-form-item>
        <el-form-item prop="currency" label="货币代码" required>
          <el-input v-model="currNew.currency" placeholder="请输入货币代码如:USD"/>
        </el-form-item>
        <el-form-item prop="CountryCode" label="国家代码" required>
          <el-input v-model="currNew.CountryCode" placeholder="国家代码，如US"/>
        </el-form-item>
        <el-form-item prop="address" label="联系地址" required>
          <el-input v-model="currNew.address" placeholder="请输入站点联系地址"/>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" size="small" @click="handle('newForm')"><i class="fa fa-hand-o-up"></i>提交新的站点</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'Sites',
  data () {
    return {
      keywords: {},
      tableDate: [],
      tableLoad: false,
      tablePage: {page: 1, total: 0},
      currNew: {},
      currEdit: {},
      addShow: false,
      editShow: false
    }
  },
  mounted () {
    this.getSites(1)
  },
  methods: {
    handle: function (form) {
      var that = this
      that.$refs[form].validate(function (valid) {
        if (valid) {
          var para = that.currNew
          para.method = 'shop.addSite'
          that.$pageloading()
          that.$http.post(that.$apiurl, para).then(function (ret) {
            that.$loadend()
            if (ret.body.data.code === 200) {
              that.$message.success('新站点申请成功!')
              that.getSites(1)
            } else {
              that.$message.error('新站点申请失败，请稍后重试!')
            }
          })
        }
      })
    },
    getSites: function (page) {
      var that = this
      var para = {}
      para.method = 'shop.usershopsites'
      para.page = page
      para.num = 15
      that.tableLoad = true
      that.$http.post(that.$apiurl, para).then(function (ret) {
        that.tableLoad = false
        that.tableDate = ret.body.data.data
        that.tablePage.page = page
        that.tablePage.total = ret.body.data.total
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/System/Sites.vue